import React, {useEffect} from 'react';

import Accordion from '../Accordion';
import Utility from '../../utils/Helper';

export default function FooterMainView({footerDetails, intl, className}) {
    useEffect(() => {
        const listEl = document.querySelectorAll('.complaint-cfm-link a');
        listEl.length > 0 &&
            footerDetails?.cfmLink &&
            listEl.forEach((el) => {
                el.setAttribute('href', footerDetails.cfmLink);
                el.setAttribute('target', '_blank');
                el.setAttribute('rel', 'noopener noreferrer');
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getLinksInfoDesktop = ({keyPostFix = ''}) => {
        return footerDetails
            ? footerDetails.footerLinks.map((links, index) => {
                  return (
                      <div key={index + keyPostFix} className='col-xl-3 col-lg-4 col-md-3 px-md-0 maxisLinks'>
                          <div className='maxis-title maxis-semiBold'>{links.title}</div>
                          {links.children.map((singleList, childIdx) => {
                              return (
                                  <a
                                      key={`${childIdx}_linkIfodesktop`}
                                      className='about-maxis-title maxis'
                                      href={singleList.path}
                                  >
                                      {singleList.title}
                                  </a>
                              );
                          })}
                      </div>
                  );
              })
            : null;
    };

    const getMiniLinksDesktop = ({keyPostFix = ''}) => {
        return footerDetails
            ? footerDetails.footerMiniLinks.map((links, index) => {
                  return (
                      <a
                          key={`${index}_miniLinkIfodesktop_${keyPostFix}`}
                          className='about-maxis-title'
                          href={links.path}
                      >
                          {links.title}
                      </a>
                  );
              })
            : null;
    };

    const getLinksInfoMobile = () => {
        return footerDetails
            ? footerDetails.footerLinks.map((links, index) => {
                  return (
                      <div key={`${index}_accordion`}>
                          <Accordion title={links.title}>
                              {links.children.map((singleList, childIdx) => {
                                  return (
                                      <a
                                          key={`${childIdx}_linkIfomobile`}
                                          className='accordion-text'
                                          href={singleList.path}
                                      >
                                          {singleList.title}
                                      </a>
                                  );
                              })}
                          </Accordion>
                          <hr className='my-0' />
                      </div>
                  );
              })
            : null;
    };

    const getMiniLinksMobile = () => {
        return footerDetails
            ? footerDetails.footerMiniLinks.map((links, index) => {
                  return (
                      <a key={`${index}_miniLinkIfomobile`} className='accordion-text' href={links.path}>
                          {links.title}
                      </a>
                  );
              })
            : null;
    };

    return (
        <div id='footerDiv' className={`footerDiv ${className}`}>
            {' '}
            <div className='container max-md-width footerContent'>
                <div className='top-footer'>
                    {(footerDetails && (
                        <div className='row mt-4 mt-lg-0'>
                            <div className='col-12 col-md-6 col-lg-12 mb-4 maxis-app-download-container'>
                                <div className='fs-14 maxis-semiBold text-clear-white mb-2'>
                                    {Utility.getValues(footerDetails, 'downloadLinks.headerText', '')}
                                </div>

                                <div className='row align-items-baseline'>
                                    {Utility.getValues(footerDetails, 'downloadLinks.links', []).map((link, index) => (
                                        <div
                                            className='col-auto app-download-icon-wrapper'
                                            key={`app-download-icon-${index}`}
                                        >
                                            <a href={link.url} rel='noopener noreferrer'>
                                                <img src={link.imageUrl} alt={link.imageAltText || ''} />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-lg-12 mb-4 maxis-social-platform-container'>
                                <div className='fs-14 maxis-semiBold text-clear-white mb-2'>
                                    {Utility.getValues(footerDetails, 'socialIcons.headerText', '')}
                                </div>

                                <div className='row align-items-baseline justify-content-between maxis-social-platform-icon-container'>
                                    {Utility.getValues(footerDetails, 'socialIcons.links', []).map((link, index) => (
                                        <div className='col-auto social-icon-wrapper' key={`social-icon-${index}`}>
                                            <a href={link.iconUrl} rel='noopener noreferrer'>
                                                <img src={link.iconImageUrl} alt={link.iconPath || ''} />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )) ||
                        null}

                    {/* {mobile-view} */}
                    <div className='collapse_links d-md-block d-xl-none d-lg-none'>
                        {getLinksInfoMobile()}
                        <Accordion title={intl.messages.tncTitle}>{getMiniLinksMobile()}</Accordion>
                        <hr className='my-0' />
                    </div>

                    {/* {desktop-view} */}
                    <div className='col-8 d-none d-sm-none d-md-none d-xl-block'>
                        <div className='right-footer'>
                            {getLinksInfoDesktop({keyPostFix: 'desktop'})}
                            <div className='col-xl-3 col-lg-4 maxisLinks'>
                                <div className='maxis-title maxis-semiBold'>{intl.messages.tncTitle}</div>
                                {getMiniLinksDesktop({keyPostFix: 'desktop'})}
                            </div>
                        </div>
                    </div>

                    {/* {md-view} */}
                    <div className='col-7 d-none d-sm-none d-md-none d-xl-none d-lg-block ml-6'>
                        <div className='right-footer'>
                            {getLinksInfoDesktop({keyPostFix: 'md'})}
                            <div className='col-lg-4 maxisLinks'>
                                <div className='maxis-title maxis-semiBold'>{intl.messages.tncTitle}</div>
                                {getMiniLinksDesktop({keyPostFix: 'md'})}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-lg-none text-white maxis-light fs-12'>
                    <div className='col d-flex flex-column pl-0 lh-normal notice-content'>
                        <div className='mb-1' dangerouslySetInnerHTML={{__html: footerDetails?.disclaimerText}} />
                        <div className='mb-1' dangerouslySetInnerHTML={{__html: footerDetails?.browserText}} />
                        <div
                            className='mb-1 complaint-cfm-link'
                            dangerouslySetInnerHTML={{__html: footerDetails?.cfmInfo}}
                        />
                        <div dangerouslySetInnerHTML={{__html: footerDetails?.companyName}} />
                    </div>
                    <div className='d-flex flex-row'>
                        <div className='copy-right-content'>{intl.messages.copyRightContentLabel}</div>
                    </div>
                </div>

                <div className='container px-0 d-none d-lg-block pt-5'>
                    <hr className='bottomLine mt-1 mb-1' />
                    <div className='d-flex justify-content-between text-white maxis-light fs-12'>
                        <div className='notice-content'>
                            <div className='mb-2px' dangerouslySetInnerHTML={{__html: footerDetails?.disclaimerText}} />
                            <div className='mb-2px' dangerouslySetInnerHTML={{__html: footerDetails?.browserText}} />
                            <div
                                className='mb-2px complaint-cfm-link'
                                dangerouslySetInnerHTML={{__html: footerDetails?.cfmInfo}}
                            />
                            <div className='d-flex'>
                                <div dangerouslySetInnerHTML={{__html: footerDetails?.companyName}} />
                                <div className='px-1'>|</div>
                                <div>
                                    <a href='/sitemap.html' target='_blank' rel='noopener noreferrer'>
                                        {intl.messages.siteMap}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className='copy-right-content'>{intl.messages.copyRightContentLabel}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
